// Title: show-media-query-dev.ts
//
// Author: Jacco van der Post <vanderpost@redkiwi.nl>
//
// Date: 16-03-2022
//

import { hasClass } from "../utils";

/**
 * Show media queries on TYPO3 development context
 */
export class ShowMediaQueryDev {
    constructor() {
        if (hasClass(document.body, "development")) {
            enum mediaQueries {
                sm = 640,
                md = 768,
                lg = 1024,
                xl = 1280,
                xxl = 1440,
            }

            let divScreensizes = document.querySelectorAll(".screensize-dev");

            divScreensizes.forEach((divScreensize) => {
                divScreensize.remove();
            });

            const element = document.querySelector(
                "body > header > .container"
            );
            if (!element) {
                return;
            }
            const containerWidth = element.clientWidth;

            let mediaQuery = "<= max639";

            if (containerWidth >= mediaQueries["sm"]) {
                mediaQuery = ">= sm";
            }

            if (containerWidth >= mediaQueries["md"]) {
                mediaQuery = ">= md";
            }

            if (containerWidth >= mediaQueries["lg"]) {
                mediaQuery = ">= lg";
            }

            if (containerWidth >= mediaQueries["xl"]) {
                mediaQuery = ">= xl";
            }

            if (containerWidth >= mediaQueries["xxl"]) {
                mediaQuery = ">= 2xl";
            }

            document
                .querySelector("body")
                .insertAdjacentHTML(
                    "afterbegin",
                    '<p class="screensize-dev fixed z-50 top-80 right-20 bg-gray-300 p-1 pt-2 font-mono text-sm" >Container width: <b>' +
                        containerWidth +
                        "</b> " +
                        mediaQuery +
                        "</p>"
                );

            divScreensizes = document.querySelectorAll(".screensize-dev");

            setTimeout(function () {
                divScreensizes.forEach((divScreensize) => {
                    divScreensize.remove();
                });
            }, 4000);
        }
    }
}
